import { SearchOutlined } from '@ant-design/icons';
import { Input, List, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { Integration, IntegrationUser, User } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';

export function RoleUserSwitch(props: { integrationId?: string; user?: User; integrationUser?: IntegrationUser }) {
  const { Option } = Select;

  const [integrationUser, setIntegrationUser] = useState(props.integrationUser);
  const [loading, setLoading] = useState(false);

  const addIntegrationUser = (notificationLevel: string) => {
    setLoading(true);

    const body = {
      userId: props.user?.id,
      notificationLevel,
    };

    apiClient
      .post(`integrations/${props.integrationId}/users`, body)
      .then((response: any) => {
        setIntegrationUser(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const removeIntegrationUser = () => {
    setLoading(true);

    apiClient
      .delete(`integrations/${props.integrationId}/users/${props.user?.id}`)
      .then(() => {
        setIntegrationUser(undefined);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSelectChange = (value: string) => {
    if (value === 'Never') {
      removeIntegrationUser();
    } else {
      addIntegrationUser(value);
    }
  };

  return (
    <List.Item
      actions={[
        <Select
          style={{ width: 150 }}
          loading={loading}
          onChange={onSelectChange}
          defaultValue={integrationUser ? integrationUser.notificationLevel : 'Never'}
        >
          <Option value="Never">Kapalı</Option>
          <Option value="ExceptionOnly">Sadece hatalar</Option>
          <Option value="AllEvents">Tüm bildirimler</Option>
        </Select>,
      ]}
    >
      <List.Item.Meta title={props.user?.fullName} description={props.user?.email} />
    </List.Item>
  );
}

export function IntegrationUsersForm(props: { integration?: Integration }) {
  const [allUsers, setAllUsers] = useState<User[]>();
  const [users, setUsers] = useState<User[]>();

  useEffect(() => {
    apiClient
      .get('users?minimal=true')
      .then((response: any) => {
        setAllUsers(response.data);
        setUsers(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, []);

  const onSearchChange = (e: any) => {
    const search = (e.target.value as string).toLocaleLowerCase();
    const filteredUsers = allUsers?.filter(
      u => (u.fullName && u.fullName.toLocaleLowerCase().includes(search)) || u.email.includes(search),
    );
    setUsers(filteredUsers);
  };

  return (
    <>
      <Input placeholder="Arama" prefix={<SearchOutlined />} style={{ marginBottom: '1rem' }} onChange={onSearchChange} />
      <List
        itemLayout="horizontal"
        dataSource={users}
        renderItem={(user: User) => {
          const integrationUser = props.integration?.relatedUsers?.find(u => u.id === user.id);
          return <RoleUserSwitch integrationId={props.integration?.id} user={user} integrationUser={integrationUser} />;
        }}
      />
    </>
  );
}
